<template>
  <a @click="logout">Log Out</a>
</template>

<script>
export default {
  props: {
    csrf: String
  },  
  
  methods: {
    logout() {
      window.axios.post('/logout', { token: this.csrf })
        .then(response => {
          window.location.href= '/'
        })
        .catch(error => {
          
        })
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/LogOutLink.vue